export default "__VITE_ASSET__DZvcaDYN__"